export default [
  {
    title: "Händelse",
    key: "MAIN",
    visited: true,
    hasError: false,
    fieldKeys: [
      "end",
      "title",
      "description",
      "content_type",
      "object_id",
      "participants",
    ],
  },
  {
    title: "Granska och slutför",
    key: "CONFIRM",
    visited: false,
    hasError: false,
    fieldKeys: [],
  },
];
